import Swal from 'sweetalert2';
import * as constants from 'src/app/shared/constants';

export class Alert {
  constructor() { }

  static defaultOptions = {
    heightAuto: false
  };

  private static getThis() {
    return this;
  }

  static getMessage() {
    return constants.default;
  }

  static success(text: any, title?: any) {
    return Swal.fire({
      icon: 'success',
      title,
      text,
      ...this.getThis().defaultOptions
    });
  }

  static info(text: any, title?: any, html?: any) {
    return Swal.fire({
      icon: 'info',
      title,
      text,
      html,
      ...this.getThis().defaultOptions
    });
  }

  static error(text: any, title?: any) {
    return Swal.fire({
      icon: 'error',
      title,
      text,
      ...this.getThis().defaultOptions
    });
  }

  static warning(text: any, title?: any) {
    return Swal.fire({
      icon: 'warning',
      title,
      text,
      ...this.getThis().defaultOptions
    });
  }

  static question(message: any) {
    return Swal.fire({
      title: `<span style=\'font-size: 16px; color: rgba(0,0,0,.64)\'>${message}</span>`,
      icon: 'question',
      confirmButtonColor: '#39b54a',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sim',
      cancelButtonText: 'Cancelar',
      showCancelButton: true,
      allowOutsideClick: true,
      ...this.getThis().defaultOptions
    });
  }

}
